// extracted by mini-css-extract-plugin
module.exports = {"box":"ArticleChunk_box_2oMWz","title":"ArticleChunk_title_2IYeL","image":"ArticleChunk_image_TLbmn","text":"ArticleChunk_text_1TrmU","url":"ArticleChunk_url_rY6_k"};